// 한 그리드에 담기는 상품 갯수
export const GridSize = 4
// 탭 당 최소 상품 갯수
export const MinProductNum = 8
// 탭 당 최대 상품 갯수
export const MaxProductNum = 48
// 최대 탭 갯수
export const MaxTabNum = 6
